import { FilterButton, OptionList, Popover } from '@servicetitan/design-system';
import { useState } from 'react';
import styles from './styles.module.css';

interface Option<T> {
  name: string;
  value: T;
}

export interface SelectFilterProps<T> {
  name: string;
  options: Option<T>[];
  optionComponent?: React.ComponentType<Option<T>>;
  onChange(value: T): void;
  value: T;
  className?: string;
  disabled?: boolean;
}

export const SelectFilter = <T,>({
  onChange,
  value,
  name,
  options,
  optionComponent: OptionComponent,
  className,
  disabled,
}: SelectFilterProps<T>) => {
  const [open, setOpen] = useState(false);

  const optionListOptions = [
    {
      options: options.map((option) => ({
        ...option,
        value: option.value,
        content: OptionComponent ? (
          <OptionComponent {...option} />
        ) : (
          option.name
        ),
      })),
    },
  ];

  return (
    <Popover
      el='span'
      direction='br'
      padding='s'
      onClickOutside={() => setOpen(false)}
      open={open}
      portal
      className={className}
      disabled={disabled}
      trigger={
        <FilterButton
          onClick={() => setOpen(true)}
          value={value ? value.toString() : undefined}
          label={name}
          expandIcon={open}
          disabled={disabled}
          className={disabled ? styles.disabledButton : undefined}
        />
      }
    >
      <OptionList
        flatGroup={true}
        options={optionListOptions}
        onChange={(data: T) => {
          setOpen(false);
          onChange(data);
        }}
        value={value}
      />
    </Popover>
  );
};
